/* tslint:disable */
/* eslint-disable */
/**
 * New Train Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { ReserveSeatResult } from '../model';
/**
 * CreateReservesApiApiReserveSeatGet - axios parameter creator
 * 
 * @summary Reserve seat for a train
 * @param {number} [trainID] 
 * @param {string} [priceId] 
 * @param {number} [seatCount] 
 * @param {number} [genderCode] 
 * @param {boolean} [exclusive] 
 * @param {boolean} [includeOptionalServices] 
 * @param {number} [adultCount] 
 * @param {number} [childCount] 
 * @param {number} [infantCount] 
 * @param {number} [billID] 
 * @param {string} [xPlayerid] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CreateReservesApiApiReserveSeatGetAxiosParamCreator (trainID?: number, priceId?: string, seatCount?: number, genderCode?: number, exclusive?: boolean, includeOptionalServices?: boolean, adultCount?: number, childCount?: number, infantCount?: number, billID?: number, xPlayerid?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/ReserveSeat`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (trainID !== undefined) {
        localVarQueryParameter['trainID'] = trainID;
    }

    if (priceId !== undefined) {
        localVarQueryParameter['PriceId'] = priceId;
    }

    if (seatCount !== undefined) {
        localVarQueryParameter['SeatCount'] = seatCount;
    }

    if (genderCode !== undefined) {
        localVarQueryParameter['GenderCode'] = genderCode;
    }

    if (exclusive !== undefined) {
        localVarQueryParameter['Exclusive'] = exclusive;
    }

    if (includeOptionalServices !== undefined) {
        localVarQueryParameter['IncludeOptionalServices'] = includeOptionalServices;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['AdultCount'] = adultCount;
    }

    if (childCount !== undefined) {
        localVarQueryParameter['ChildCount'] = childCount;
    }

    if (infantCount !== undefined) {
        localVarQueryParameter['InfantCount'] = infantCount;
    }

    if (billID !== undefined) {
        localVarQueryParameter['BillID'] = billID;
    }

    if (xPlayerid != null) {
        localVarHeaderParameter['x-playerid'] = String(xPlayerid);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiReserveSeatGet operation in CreateReservesApi.
 * @export
 * @interface CreateReservesApiApiReserveSeatGetRequest
 */
export interface CreateReservesApiApiReserveSeatGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly trainID?: number

    /**
     * 
     * @type {string}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly priceId?: string

    /**
     * 
     * @type {number}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly seatCount?: number

    /**
     * 
     * @type {number}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly genderCode?: number

    /**
     * 
     * @type {boolean}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly exclusive?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly includeOptionalServices?: boolean

    /**
     * 
     * @type {number}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly childCount?: number

    /**
     * 
     * @type {number}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly infantCount?: number

    /**
     * 
     * @type {number}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly billID?: number

    /**
     * 
     * @type {string}
     * @memberof CreateReservesApiApiReserveSeatGet
     */
    readonly xPlayerid?: string
}

/**
* 
* @summary Reserve seat for a train
* @param {CreateReservesApiApiReserveSeatGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CreateReservesApiApiReserveSeatGet(requestParameters: CreateReservesApiApiReserveSeatGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CreateReservesApiApiReserveSeatGetAxiosParamCreator(requestParameters.trainID, requestParameters.priceId, requestParameters.seatCount, requestParameters.genderCode, requestParameters.exclusive, requestParameters.includeOptionalServices, requestParameters.adultCount, requestParameters.childCount, requestParameters.infantCount, requestParameters.billID, requestParameters.xPlayerid, options, configuration);
    const request: () => AxiosPromise<ReserveSeatResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
